const Notify = {
  methods: {
    notifyInfo(text, title = "Info") {
      this.$notify({
        title,
        text,
        type: "success",
      });
    },

    notifyWarn(text, title = "Warning") {
      this.$notify({
        title,
        text,
        type: "warn",
      });
    },

    notifyError(text, title = "Error") {
      this.$notify({
        title,
        text,
        type: "error",
      });
    },

    notifySuccess(text, title = "Success") {
      this.$notify({
        title,
        text,
        type: "success",
      });
    },
  },
};

export default Notify;



// WEBPACK FOOTER //
// ./src/notify.js